(() => {
  const header = document.querySelector('[data-korker-header]');
  const updateHeader = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.korker-header__mobile-menu[open]').forEach((menu) => {
      menu.removeAttribute('open');
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-korker-quick-add]');
    if (!form || !window.routes?.cart_add_url) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const originalText = button?.textContent;

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      const formData = new FormData(form);
      const drawer = document.querySelector('cart-drawer');

      if (drawer?.getSectionsToRender) {
        formData.append(
          'sections',
          drawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!response.ok) throw new Error('Cart add failed');

      const cartResponse = await fetch(window.routes.cart_url + '.js');
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count;
      });

      if (drawer?.renderContents) {
        drawer.renderContents(await response.json());
      } else if (drawer?.open) {
        drawer.open();
      }
    } catch (error) {
      form.submit();
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });
})();
